const contactInfo = [
  {
    group: 'Address',
    icon: 'ri-map-pin-2-line',
    items: [
      { label: 'Street', value: 'Marsala Tita bb' },
      { label: 'City', value: 'Kozarac' },
      { label: 'ZIP Code', value: '79202' },
      { label: 'Country', value: 'Bosnia and Herzegovina' },
    ],
  },
  {
    group: 'Contact',
    icon: 'ri-contacts-line',
    items: [
      { label: 'Email', value: 'help@primadoo.net' },
      { label: 'Phone', value: '+1 7407373735' },
    ],
  },
];

export default function ContactSection() {
  return (
    <section id="contact" className="py-28" style={{ background: 'rgb(30,30,30)' }}>
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Top row */}
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-16 pb-10 border-b border-white/10">
          <div>
            <p className="text-xs uppercase tracking-[0.3em] text-white/40 mb-4 font-medium">Get In Touch</p>
            <h2 className="text-4xl md:text-5xl font-light text-white leading-tight">
              Contact <span className="font-semibold">PRIMA d.o.o.</span>
            </h2>
          </div>
          <p className="text-white/50 text-sm max-w-xs leading-relaxed">
            Have questions about our iOS products? We&apos;re here to help. Reach out to our team anytime.
          </p>
        </div>

        {/* Contact grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 mb-16">
          {contactInfo.map((group) => (
            <div key={group.group} className="bg-white/5 border border-white/10 rounded-2xl p-8">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-white/10">
                  <i className={`${group.icon} text-base text-white/70`} />
                </div>
                <h3 className="text-sm font-semibold text-white tracking-wide">{group.group}</h3>
              </div>
              <div className="flex flex-col gap-4">
                {group.items.map((item) => (
                  <div key={item.label} className="flex flex-col gap-0.5">
                    <span className="text-xs text-white/40 uppercase tracking-wider font-medium">{item.label}</span>
                    <span className="text-sm text-white/80 font-light">{item.value}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Full address block */}
        <div className="bg-white/5 border border-white/10 rounded-2xl p-8 mb-16">
          <h3 className="text-xs uppercase tracking-[0.3em] text-white/40 mb-5 font-medium">Full Address</h3>
          <address className="not-italic flex flex-wrap gap-x-8 gap-y-3">
            <div className="flex flex-col gap-0.5">
              <span className="text-xs text-white/40 uppercase tracking-wider font-medium">Street</span>
              <span className="text-sm text-white/80">Marsala Tita bb</span>
            </div>
            <div className="flex flex-col gap-0.5">
              <span className="text-xs text-white/40 uppercase tracking-wider font-medium">City</span>
              <span className="text-sm text-white/80">Kozarac</span>
            </div>
            <div className="flex flex-col gap-0.5">
              <span className="text-xs text-white/40 uppercase tracking-wider font-medium">ZIP Code</span>
              <span className="text-sm text-white/80">79202</span>
            </div>
            <div className="flex flex-col gap-0.5">
              <span className="text-xs text-white/40 uppercase tracking-wider font-medium">Country</span>
              <span className="text-sm text-white/80">Bosnia and Herzegovina</span>
            </div>
            <div className="flex flex-col gap-0.5">
              <span className="text-xs text-white/40 uppercase tracking-wider font-medium">Email</span>
              <span className="text-sm text-white/80">help@primadoo.net</span>
            </div>
            <div className="flex flex-col gap-0.5">
              <span className="text-xs text-white/40 uppercase tracking-wider font-medium">Phone</span>
              <span className="text-sm text-white/80">+1 7407373735</span>
            </div>
          </address>
        </div>

        {/* Footer bottom */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 pt-8 border-t border-white/10">
          <div className="flex items-center gap-2">
            <span className="w-2 h-2 rounded-sm bg-white/40" />
            <span className="text-white/60 text-sm font-medium tracking-widest">PRIMA d.o.o.</span>
          </div>
          <p className="text-white/30 text-xs text-center sm:text-right">
            &copy; {new Date().getFullYear()} PRIMA d.o.o. All rights reserved. iOS App Development — Kozarac, Bosnia and Herzegovina.
          </p>
        </div>
      </div>
    </section>
  );
}
